import { jsxs as o, jsx as n } from "react/jsx-runtime";
import { c } from "../../../../clsx-OuTLNxxd.js";
import { forwardRef as m } from "react";
const p = "_container_bhrfx_1", d = "_message_bhrfx_6", f = "_error_bhrfx_12", u = "_disabled_bhrfx_25", e = {
  container: p,
  message: d,
  error: f,
  "input-container": "_input-container_bhrfx_19",
  disabled: u,
  "checkbox-input": "_checkbox-input_bhrfx_28",
  "label-container": "_label-container_bhrfx_75"
}, k = m(
  ({ label: t, value: i, onChange: l, name: _, message: s, hasError: a, disabled: r, checked: b }, x) => {
    const h = c(e["checkbox-input"], a && e.error, r && e.disabled);
    return /* @__PURE__ */ o("div", { className: e.container, children: [
      /* @__PURE__ */ o("label", { className: c(e["input-container"], r && e.disabled), children: [
        /* @__PURE__ */ n(
          "input",
          {
            type: "checkbox",
            className: h,
            name: _,
            value: i,
            onChange: l,
            disabled: r,
            checked: b,
            ref: x
          }
        ),
        /* @__PURE__ */ n("div", { className: e["label-container"], children: t })
      ] }),
      s && /* @__PURE__ */ n("span", { className: c(e.message, a && e.error), children: s })
    ] });
  }
);
k.displayName = "Checkbox";
export {
  k as Checkbox
};
